import { render, staticRenderFns } from "./TermsFilterLink.vue?vue&type=template&id=42f1518d&scoped=true&"
import script from "./TermsFilterLink.vue?vue&type=script&lang=js&"
export * from "./TermsFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1518d",
  null
  
)

export default component.exports